<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="我的销售业绩" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div>
          <div>
            <el-form :inline="true" :model="form">
              <el-form-item>
                <month-picker @change="setTime"></month-picker>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="query(query)">查询</el-button>
              </el-form-item>

              <el-form-item>
                <el-button @click="exportList" class="jc-button-icon"
                  ><i class="jc-icon-download"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <div class="jc-container-table-row" style="margin: 15px 0px">
            业绩总计：<span class="jc-font-size-large">{{
              achievmentTotal | formatMoney
            }}</span>

            元
          </div>

          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column label="日期">
              <template slot-scope="scope">{{
                scope.row.consumeDate | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="消费金额(元)">
              <template slot-scope="scope">{{
                scope.row.consumeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="现金支付(元)">
              <template slot-scope="scope">{{
                scope.row.cashPayFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="付费代金券(元)">
              <template slot-scope="scope">{{
                scope.row.payCouponFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column>
              <template slot="header">
                免费代金券(元)
                <el-tooltip
                  content="免费代金券不计入销售业绩"
                  placement="top-end"
                >
                  <i class="jc-icon-my-help"></i>
                </el-tooltip>
              </template>

              <template slot-scope="scope">{{
                scope.row.freeCouponFeeCount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="计入业绩金额(元)">
              <template slot-scope="scope">{{
                scope.row.achievmentCount | formatMoney
              }}</template>
            </el-table-column>
          </el-table>

          <div class="jc-container-table-actionBar" v-if="total > 10">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageIndex"
              :page-sizes="[10, 20, 50]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryMyAchievment, exportMyAchievment } from '@/api/distributor-api.js'
import { getDate } from '@/utils'
import routerMixins from '@/mixins/router-mixins.js'
import MonthPicker from '@/views/business/models/MonthPicker.vue'
export default {
  mixins: [routerMixins],
  components: {
    MonthPicker,
  },
  data() {
    return {
      form: {
        pageSize: 10,
        pageIndex: 1,
        beginTime: getDate(new Date()).ym,
        endTime: getDate(new Date()).ym,
      },
      achievmentTotal: '',
      total: 0,
      tableData: [],
    }
  },
  created() {
    this.query()
  },
  methods: {
    setTime(time) {
      let { beginTime, endTime } = time
      this.form.beginTime = beginTime || ''
      this.form.endTime = endTime || ''
    },
    handleSizeChange(val) {
      this.form.pageSize = val
      this.query()
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val
      this.query()
    },
    async exportList() {
      let { result } = await exportMyAchievment(this.form)
      window.location.href = eval("'" + result.uri + "'")
    },
    async query(query) {
      if (query) {
        this.form.pageIndex = 1
      }
      try {
        let { result } = await queryMyAchievment(this.form)
        this.achievmentTotal = result && result.achievmentTotal
        this.tableData = (result && result.result) || []
        this.total =
          (result && result.pagination && result.pagination.numberRecords) || 0
      } catch (err) {
        this.tableData = []
        this.total = 0
      }
    },
  },
}
</script>
